import React, { useState, useEffect } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import Fetcher from '../../Common/Fetch';
import { Payment } from "../../MyActivity/types";
import DocumentLink from "../../Admin/DocumentLink";
import { PaymentStatuses } from "../../Common/types";
import { Row } from "primereact/row";

import Popup from "../../Popups/Popup";

function PaidDeposit() {
    // свойство которое хранит в себе список платежей по лотам и следит за изменениями в этих записях. Реагируя на изменения перерисовкой частей комопннета.
    const [rowsData, setRowsData] = useState<Payment[]>([]);

    // сообщение об ошибки
    const [error, setError] = useState({ isError: false, message: '' });

    // блокирует таблицу на момент загрузки данных
    const [loading, setLoading] = useState(true);

    // нажата кнопка Возврат или нет
    const [isReturnButtonClicked, setIsReturnButtonClicked] = useState(false);

    // есть ли банковские данные в профиле
    const [haveBankData, setHaveBankData] = useState(false);

    // id оплаты
    const [paymentId, setPaymentId] = useState(0);

    // Состояние для управления попапом с причиной отказа
    const [isReasonPopupVisible, setIsReasonPopupVisible] = useState(false);
    const [declineReason, setDeclineReason] = useState('');

    // хук который взывается после загрузки компонента и выполняет подгрузку данных с сервера
    useEffect(() => {
        init();
    }, []);

    // метод инициализации компонента. Запрашивает данные для таблицы с сервера.
    const init = () => {
        if (rowsData.length === 0) {
            console.log("init start");
            Fetcher('/TradeLotApi/GetPaymentsDepositBuyer/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log("get data", data);
                    if (data.Success) {
                        console.log("data", data.UpdatedItem);

                        // Маппим данные от сервера на интерфейс Payment
                        const mappedData = data.UpdatedItem.map(item => {
                            console.log("item", item);
                            return {
                                PaymentTypeName: item.PaymentTypeName,
                                PaymentStatusName: item.PaymentStatusName,
                                RefundTypeName: item.RefundTypeName,
                                RefundStatusName: item.RefundStatusName,
                                DateCreated: item.DateCreated,
                                DocumentName: item.DocumentName,
                                PaymentDeclineReason: item.PaymentDeclineReason,
                                RefundDeclineReason: item.RefundDeclineReason,
                                Sum: item.Sum,
                                Payer: item.Payer,
                                ItemId: item.ItemId,
                                DateTimeReturn: item.DateTimeReturn,
                                PaymentStatusDescription: item.PaymentStatusDescription,
                                PaymentTypeDescription: item.PaymentTypeDescription,
                                RefundTypeDescription: item.RefundTypeDescription,
                                RefundStatusDescription: item.RefundStatusDescription,
                                ItemName: item.ItemName,
                                DocumentPath: item.DocumentPath,
                                LotName: item.LotName,
                                Seller: item.Seller,
                                PaymentId: item.PaymentId,
                                RefundId: item.RefundId,
                                IsWinner: item.IsWinner,
                                RefundDocumentName: item.RefundDocumentName,
                                RefundDocumentPath: item.RefundDocumentPath
                            };
                        });

                        setRowsData(mappedData);
                    } else {
                        setError({ isError: true, message: 'Не удалось загрузить данные' });
                    }
                    setLoading(false);
                })
                .catch(error => {
                    setError({ isError: true, message: 'Ошибка при загрузке данных' });
                    setLoading(false);
                });
        }
    };

    const formatDate = (date) => {
        return date
            ? new Intl.DateTimeFormat("ru-RU", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            }).format(new Date(date))
            : "-";
    };

    const returnDeposit = async (paymentId) => {
        console.log("paymentId", paymentId);
        try {
            const response = await Fetcher("/TradeLotApi/ReturnDeposit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(paymentId)
            });

            if (response.ok) {
                const data = await response.json();
                console.log("returnDeposit data:", data);

                if (data.Error) {
                    setError(prev => ({
                        ...prev,
                        message: data.Error
                    }));
                } else {
                    console.log(data.UpdatedItem.RefundStatusId);
                    console.log(data.UpdatedItem.RefundStatusDescription);
                    setRowsData(prevRows =>
                        prevRows.map(row =>
                            row.PaymentId === paymentId
                                ? {
                                    ...row,
                                    RefundStatusName: data.UpdatedItem.RefundStatusName,
                                    RefundStatusDescription: data.UpdatedItem.RefundStatusDescription
                                }
                                : row
                        )
                    );
                }
            } else {
                console.error("Ошибка в запросе:", response.statusText);
            }
        } catch (error) {
            console.error("Исключение", error);
        }
    }

    useEffect(() => {
        setIsReturnButtonClicked(false);
    }, [rowsData]);

    // Обработчик для открытия попапа с причиной отказа
    const handleShowReason = (reason) => {
        setDeclineReason(reason);
        setIsReasonPopupVisible(true);
    };

    const checkProfile = async (paymentId) => {
        console.log("paymentId in checkProfile", paymentId);
        try {
            const response = await Fetcher("/ProfileApi/CheckProfile", {
                method: "GET"
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Есть ли данные профиля", data);
                setHaveBankData(data.Success);
                setPaymentId(paymentId);
                setIsReturnButtonClicked(true);
            } else {
                console.error("Ошибка", response.statusText);
            }
        } catch (error) {
            console.error("Исключение", error);
        }
    }

    useEffect(() => {
        console.log("paymentId", paymentId);
    }, [paymentId])

    useEffect(() => {
        console.log("rowsData", rowsData);
    }, [rowsData])

    const canReturnDeposit = (returnStatus) => {
        const canRefund = returnStatus !== PaymentStatuses[PaymentStatuses.IsRefundInProcess] &&
            returnStatus != PaymentStatuses[PaymentStatuses.IsRefundFinished];

        console.log("canReturnDeposit", canRefund);
        console.log("returnStatus", returnStatus);

        return canRefund;
    }

    const renderProfileInfoPopupBody = () => {
        if (error.isError) return <p>{error.message}</p>
    }

    const renderProfileInfoButtons = () => {
        if (haveBankData) return [{ name: "Да", action: () => returnDeposit(paymentId) }, { name: "Нет", action: () => setIsReturnButtonClicked(false) }]
    }

    return (
        <React.Fragment>
            <div className="lotsWrapper depositTableWrapper">
                <DataTable
                    value={rowsData}
                    className="defaultTable"
                    emptyMessage="Здесь пусто"
                >
                    <Column field="DateCreated" header="Дата" body={(rowData) => formatDate(rowData.DateCreated)} />
                    <Column
                        field="LotName"
                        header="Лот"
                        body={(rowData) => (
                            <DocumentLink
                                documentName={rowData.LotName}
                                documentPath={rowData.ItemId ? `/TradeLot/View/${rowData.ItemId}` : "#"}
                                blank={rowData.ItemId ? true : false}
                                download={false}
                            />
                        )}
                    ></Column>
                    <Column field="Seller" header="Продавец"></Column>
                    <Column
                        header="Статус"
                        body={(rowData) => {
                            if (rowData.RefundStatusName === PaymentStatuses[PaymentStatuses.DeclineRefund] ||
                                rowData.PaymentStatusName === PaymentStatuses[PaymentStatuses.NotAccepted]) {
                                return (
                                    <div>
                                        {rowData.RefundStatusName === PaymentStatuses[PaymentStatuses.DeclineRefund] && <button
                                            style={{ marginLeft: '10px', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer' }}
                                            onClick={() => handleShowReason(rowData.RefundDeclineReason)}
                                        >
                                            <span>{rowData.RefundStatusDescription}</span>
                                        </button>}
                                        {(rowData.PaymentStatusName === PaymentStatuses[PaymentStatuses.NotAccepted] &&
                                            rowData.RefundStatusName !== PaymentStatuses[PaymentStatuses.DeclineRefund]) && <button
                                            style={{ marginLeft: '10px', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer' }}
                                            onClick={() => handleShowReason(rowData.PaymentDeclineReason)}
                                        >
                                            <span>{rowData.PaymentStatusDescription}</span>
                                        </button>}
                                    </div>
                                );
                            }
                            return <span>{rowData.RefundStatusDescription ?? rowData.PaymentStatusDescription}</span>;
                        }}
                    />
                    <Column
                        header="Документы"
                        body={(rowData) => {
                            const hasRefundDocument = rowData.RefundDocumentName && rowData.RefundDocumentPath;
                            console.log("hasRefundDocument", hasRefundDocument);
                            return <DocumentLink
                                documentName={hasRefundDocument ? rowData.RefundDocumentName : rowData.DocumentName}
                                documentPath={hasRefundDocument ? rowData.RefundDocumentPath : rowData.DocumentPath}
                                download={true}
                                blank={false}
                            />
                        }}
                    ></Column>
                    <Column
                        header="Действия"
                        body={(rowData) => {
                            if (canReturnDeposit(rowData.RefundStatusName) && !rowData.IsWinner) { 
                                return (
                                    <button
                                        style={{ backgroundColor: "#28a745", color: "white", borderRadius: 10, width: 90, textAlign: "center", padding: "5px" }}
                                        onClick={() => checkProfile(rowData.PaymentId)} 
                                    >
                                        Вернуть
                                    </button>
                                );
                            }
                            return null; // Если возврат невозможен, ничего не отображаем
                        }}
                    ></Column>
                </DataTable>

                {/* Попап с причиной отказа */}
                <Popup
                    isOpen={isReasonPopupVisible}
                    close={() => setIsReasonPopupVisible(false)}
                    head={{ title: "Причина отказа", description: declineReason }}
                />

                <Popup
                    isOpen={isReturnButtonClicked}
                    close={() => setIsReturnButtonClicked(false)}
                    head={{
                        title: "Информация о профиле",
                        description: haveBankData ? "Вывести средства на указанные банковские реквизиты в вашем профиле?" : "Нет данных банка или ИНН. Заполнить данные можно в профиле."
                    }}
                    body={renderProfileInfoPopupBody}
                    actionButtons={renderProfileInfoButtons()}
                />
            </div>
        </React.Fragment>
    )
}

export default PaidDeposit;
